import {z} from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

// smaller version to support caching in BE
// see https://github.com/github/marketing-platform-services/issues/3261
export const TemplateWhitepaperTruncatedSchema = buildEntrySchemaFor('templateWhitepaper', {
  fields: z.object({
    heading: z.string(),
    contentType: z.string(),
    featuredImage: AssetSchema,
    excerpt: RichTextSchema,
  }),
})

export type WhitepaperTruncated = z.infer<typeof TemplateWhitepaperTruncatedSchema>
